import { ProductsAsVariantsConfigurationSchema } from "@redotech/redo-model/products-as-variants/products-as-variants-configuration";
import * as z from "zod/v4";

export const updateProductsAsVariantsConfigurations = {
  name: "updateProductsAsVariantsConfigurations" as const,
  input: z.object({
    enabled: z.boolean(),
    configurations: z.array(ProductsAsVariantsConfigurationSchema),
  }),
  output: z.object({}),
};
